import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search-dropdown",
  "use": "icon-search-dropdown-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"icon-search-dropdown\">\n  <path d=\"M5.11766 6.9287L8.16329 10.4829C8.21238 10.5401 8.27328 10.5861 8.3418 10.6176C8.41033 10.6491 8.48486 10.6654 8.56028 10.6654C8.6357 10.6654 8.71023 10.6491 8.77876 10.6176C8.84728 10.5861 8.90818 10.5401 8.95727 10.4829L12.0029 6.9287C12.2936 6.58945 12.0526 6.06543 11.6059 6.06543H5.51378C5.06711 6.06543 4.82613 6.58945 5.11766 6.9287Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol